import styled from '@emotion/styled';
import { FormError } from 'ui/components/elements/FormError/FormError';
import { FormInput } from 'ui/components/elements/FormInput/FormInput';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    max-height: 80vh;
    padding: 40px;
`;

const Descriptions = styled.div`
    overflow-y: auto;
`;

const Desc = styled.p`
    margin-block: 12px 20px;
    padding: 0 4px;
    white-space: pre-line;
    font-weight: var(--font-bold);
`;

const FormWrapper = styled.div`
    width: 100%;
`;

const SubmitButton = styled.button`
    width: 80%;
    max-width: 200px;
    background-color: var(--primary);
    color: var(--white);
    font-size: var(--font-large);
    font-weight: var(--font-bold);
    padding: 15px;
    border-radius: 25px;
    cursor: pointer;
    margin: 10px auto 0 auto;
    border: none;
    outline: none;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }
`;

const ErrorMsgContainer = styled.div`
    margin-right: auto;
`;

interface Props {
    setValue: (value: string) => void;
    onClick: () => void;
    errorMsg: string;
    disabled?: boolean;
}

/**
 * 招待モーダル
 */
export const InviteUserModal: React.FC<Props> = ({ setValue, onClick, errorMsg, disabled = false }) => {
    return (
        <Wrapper>
            <Descriptions>
                <Desc>メンバー招待</Desc>
            </Descriptions>
            <FormWrapper>
                <FormInput placeholder="メールアドレスを入力" onChange={(e) => setValue(e.target.value)} />
            </FormWrapper>
            <ErrorMsgContainer>{errorMsg && <FormError message={errorMsg} />}</ErrorMsgContainer>

            <SubmitButton onClick={onClick} disabled={disabled}>
                招待メールを送信
            </SubmitButton>
        </Wrapper>
    );
};
